define('app/views/vue/store/store',['vuex', 'Vue', 'moment', 'underscore','jquery', './pmsCheckin', './alerts'], function (Vuex, Vue, moment, _,$, pmsCheckinModule, alertsModule) {
    var localStrings = app.localization.spaBooking.packageBooking;
    var activeStepNameMap = ['Select','Schedule'];
    var mutationsWhichTriggerUrlChange = ['setSelectedCategoryFilter','setActiveCategory','setselectedDateOnDateBar', 'setActiveService'];

    function fetchInitialUser(){
        var users = {};
        users[app.data.CustomerId || app.data.DefaultCustomerId] = {};
        return users;
    }

    var _state = {
        loginUserType:'',
        firstName: '' || app.data.FirstName,
        currentRoute: 'profile',
        isValidEmail:'',
        users: fetchInitialUser(),
        selectedServices: {},
        guestProfiles:{}, //as a part of age restriction
        loggedInUser: null,
        activeStep:0,
        activeUser: 0,
        activePackageItem: 0,
        isFetching: false,
        groupMembers: [],
        currentlyEditingService: 0,
        reservedTimes: {},
        showLoaderForBooking: false,
        folioTotal: 0,
        status: "",
        afterDeleteData: [],
        packageErrorMessage: [],
        usersWithIds: {},
        desktopMode: false, // for mobile support
        HiddenReservedPackageItems: {}, // this is to store package items when user edit one of the package item. This is used to put back items in reserved times if user cancel editing
        UserCalenderEvents: [],
        UserCalenderEventsSplitDays:[],
        forceUpdate: false,
        globalMessages: [/*{type: 'success',message:'ssup'}*/],
        globalMessagesTimoutIds: {},
        showSummaryOnSideBar:true,
        selectedDateOnDateBar: "", // selected date for active service; could be through user click or prefered date was set before
        mobileViewMessages:{},
        viewMode: false,
        bookingButtonText:"",
        is_body_blur: false,
        selectedTimeOnTimePicker: "",
        selectedDateTimeOnTimePicker: null,
        showMobileItineraryDropDown:false,
        showLoaderOnStaffChange: false,
        // below is for selection Screen. For changing url.
        activeCategory: null,
        activeService: null,
        allCategories: [],
        services: {},
        packages: {},
        bookForAllGuestCheckBox: false,
        errorMessage:"",
        bookingProgressPerUser:1,
        mobileCategoryShow:true,
        ReviewScreenBookingDetails: {
            serviceName: "",
            bookings: []
        },
        urlUpdated: false,
        dataForBookingService:{}, //store actual changed data 
        bookFromCart: false,
        detectedChanges: { //this is for detecting changes and toggling  boolean value
            note: false,
            time: false,
            staff:false
        },
        editingFolioItemId: null,
        selectedCategoryFilter: 'All',
        tempCustomerId: null,
        currentlyBookingClassProgram:{}, // part of new feature in 7.6 (optional class program)
        scheduleBtnValidityPerUser:{},
        ageRestrictionErrMessages:{},
        listOfUsersWithService:{},
        firstTimeOtbBook: false,
        isAgeValid: false,
        dynamicRestErrorMessage:'',
        lastFetchDate:'',
        noAvails: false,

    }

    function initialState() {
        return JSON.parse(JSON.stringify(_state));
    }
    var storeCache = function (store) {
        if (app.data.store && app.data.store.WebFolioId == app.data.WebFolioId) {
            store.commit('setStore', app.data.store.state);
        }
        store.subscribe(function (mutation, state) {
            if (!app.data.store) app.datal('store', {});
            if (!app.data.store.WebFolioId || app.data.store.WebFolioId != app.data.WebFolioId) app.datal('store', {
                WebFolioId: app.data.WebFolioId
            });
            if(['addUser','removeGuestMember','setLoggedInUser'].indexOf(mutation.type) > -1) {
                var guestListArr = []
                if(mutation.type == 'setLoggedInUser') {
                    guestListArr.push({id:app.data.CustomerId, name:app.data.FirstName +" "+app.data.LastName})
                } else {
                    guestListArr = Object.keys(state.users).map(function(userId){
                         return {id:userId, name:state.usersWithIds[userId]};
                     });
                }
                app.datal('store', _.extend(app.data.store, {
                    selectedGroupMembers: guestListArr,
                }));
            }
            var newState = _.pick(state, 'users', 'selectedServices', 'reservedTimes','status','guestProfiles');
            app.datal('store', _.extend(app.data.store, {
                state: newState
            }));
        })
    }

    function getDispatcherArr(state){
        var selectedDate = state.selectedDateOnDateBar.length>0 ? moment(state.selectedDateOnDateBar,localStrings.stepper.body.schedule.dateBarDaysFormat).format('YYYY-MM-DD') : '';
        var stepName = state.status=='E' && state.activeStep==1 ? 'Edit' : activeStepNameMap[state.activeStep];
        var dispatcherArr = ['Location'+app.models.spaModel.getSelectedItem('spaLocations').LocationId,stepName, state.selectedCategoryFilter, state.activeCategory, selectedDate,stepName=='Edit' ? state.editingFolioItemId : state.activeService ];
        return dispatcherArr;
    }
    var urlUpdater = function (store) {
        store.subscribe(function (mutation, state) {
            if(mutation.type=="setDispactherMethod") return;
            if(state.urlUpdated) {
                store.commit("setUrlUpdated" ,false);
                return;
            }
            if( mutationsWhichTriggerUrlChange.indexOf(mutation.type)>-1 && !mutation.payload.doNotUpdate ) {
                // app.datal('donotReRunVueApp',true);
                var dispatcherArr = getDispatcherArr(state);
                // var methodOverride = mutation.type == "setselectedDateOnDateBar" ? 'replace' : false
                app.dispatcher.updateURL('spaBooking','package', dispatcherArr, true);
                // app.dispatcher[methodOverride || state.dispatcherMethod]('spaBooking','package', dispatcherArr);
            }
        })
    }

    return new Vuex.Store({
        plugins: [storeCache, urlUpdater],
        modules: {
            pmsCheckin : pmsCheckinModule,
            alerts : alertsModule
        },
        state: initialState(),
        mutations: {
            setLoginUserType: function(state, payload) {
                state = _.extend(state, payload)
            },
            setCurrentRoute: function(state, payload) {
                state = _.extend(state, payload)
            },
            setFirstName: function(state, payload) {
                state = _.extend(state, payload)
            },
            setIsValidEmail: function(state, payload) {
                state = _.extend(state, payload)
            },
            setSelectedDateTimeOnTimePicker: function(state,payload){
                state.selectedDateTimeOnTimePicker = payload.dateTime;
            },
            updateStoreOnUrlChange: function(state,payload){
                var params = {doNotUpdate:true}
                if(activeStepNameMap.indexOf(payload.activeStep)>-1) {
                    this.commit('setActiveStep',_.extend({},params,{step:payload.activeStep}));
                }
                if(!!payload.categoryFilter && ['All','Services','Packages'].indexOf(payload.categoryFilter)>-1) {
                    state.selectedCategoryFilter = payload.categoryFilter;
                }
                if(!!payload.category) {
                    var allCategories = state.allCategories
              
                    if(state.selectedCategoryFilter == localStrings.stepper.body.pick.serviceTitle){
                        allCategories = state.allCategories.filter(function(cat){ return cat != 'Spa Package' })
                    }
                    if(state.selectedCategoryFilter == localStrings.stepper.body.pick.packageTitle){
                        allCategories = state.allCategories.filter(function(cat){ return cat == 'Spa Package' })
                    }
                    if(allCategories.indexOf(payload.category)>-1)
                        state.activeCategory = payload.category;
                }
                if(moment(payload.date, 'YYYY-MM-DD', true).isValid()) {
                    var formattedDate = moment(payload.date,'YYYY-MM-DD').format(localStrings.stepper.body.schedule.dateBarDaysFormat)
                    state.selectedDateOnDateBar = formattedDate;
                }
            },
            setSelectedCategoryFilter: function(state, payload){
                state.selectedCategoryFilter = payload.filter;
            },
            addDataToPackagesFromFolio: function(state,payload){
                if(!payload.userId) throw('no user id provided');
                var package_s = state.users[payload.userId][payload.itemId];
                var package_p = payload.package;
                package_p_without_PIs = _.omit(package_p,'PackageItems');
                package_s.package_item = _.extend(package_s.package_item,package_p_without_PIs); 
                package_p.PackageItems.PackageItem.forEach(function(pi){
                    // pi = JSON.parse(JSON.stringify(pi))
                    // var pi_s = _.find(package_s.package_item.PackageItems.PackageItem,function(item){ return item.SpaItemId == pi.SpaItemId });
                    // pi_s = _.extend(pi,pi_s);
                    package_s.package_item.PackageItems.PackageItem.some(function(pi_s,index){
                        if(pi_s.SpaItemId ==  pi.SpaItemId ){
                            state.users[payload.userId][payload.itemId].package_item.PackageItems.PackageItem[index] = _.extend({},pi,pi_s);
                            return true;
                        }
                        return false;
                    })
                });
            },
            setEditingFolioItemId: function(state,folioItemId){
 
                state.editingFolioItemId = folioItemId;
            },
            setScheduleBtnValidity: function(state,payload){
                var newState = {}
                newState = _.extend({},state.scheduleBtnValidityPerUser)
                if(payload.action == "add"){
                    //only one person can be selected at a time. So remove other data it may exist
                    if(payload.isPackage)  newState = {}
                     newState[payload.id] = payload.status
                }
                else {
                    
                  payload.removeAll? newState={}:
                    delete newState[payload.id]
                }
                    state.scheduleBtnValidityPerUser = _.extend({}, newState);
            },
            setAgeRestrictionErrMessages: function(state,payload){
                var newState = {}
                newState = _.extend({},state.ageRestrictionErrMessages)
                newState[payload.id] = payload.message
                state.ageRestrictionErrMessages = _.extend({}, newState);
            },
            setUrlUpdated: function(state,bool){
                state.urlUpdated = bool;
            },
            addAllServices: function(state,payload){
                state.services = _.extend({},payload);
            },
            addAllPackages: function(state,payload){
                _.each(payload,function (val,key) {
                    val.PackageItems.PackageItem = [].concat(val.PackageItems.PackageItem)
                })
                state.packages = _.extend({},payload);
            },
            addCategory: function(state,payload){
                if(state.allCategories.indexOf(payload.name)>-1) return;
                state.allCategories.push(payload.name);
            },
            removeAllCategories: function(state) {
                state.allCategories = [];
            },
            clearAllServicesAndPackages: function(state) {
                state.services = {};
                state.packages = {};
            },
            SetbookFromCart: function(state,bool){
                state.bookFromCart = bool
            },
            setActiveCategory: function(state,payload){
                state.activeService = null;
                state.activeCategory = payload.category;
            },
            setDetectedChanges: function(state,payload){
                if(_.isEmpty(payload)) {
                    _.each(Object.keys(state.detectedChanges),function(key){
                        state.detectedChanges[key] = false
                    })
                    return;
                }
                state.detectedChanges[payload.key] = payload.value
            },
            setdataForBookingService: function(state,payload){
                if(_.isEmpty(payload)){
                    state.dataForBookingService = {}
                    return;
                }
                var newd = _.extend({}, state.dataForBookingService);
                var key = Object.keys(payload)[0]
                var value = _.values(payload)[0]
                newd[key] = value
               // state.dataForBookingService[key] = value
                state.dataForBookingService = _.extend({}, newd);
            },
            setActiveService: function(state,payload){
                var id = payload.doNotUpdate ? payload.id : payload;
                state.activeService = id;
            },
            setFirstTimeOtbBook: function(state,payload){
                state.firstTimeOtbBook = payload
            },
            setActiveSpaLocation: function(state,payload){
                state.spaLocationId = payload
            },
            setOTBactive: function(state,payload){
                state.OTBactive = payload
            },
            setActiveTimePickerSlot: function(state,payload){
                state.ActiveTimePickerSlot = payload;
            },
            setErrorMessage:function(state,val){
                state.errorMessage = val
            },
            setBookingProgressPerUser:function(state,val){
                state.bookingProgressPerUser = val
            },
            setmobileCategoryShow:function(state,val){
                state.mobileCategoryShow = val  
            },
            setReviewScreenBookingDetails:function(state,payload){
                if(_.isEmpty(payload)){
                    state.ReviewScreenBookingDetails.bookings = []
                    state.ReviewScreenBookingDetails.service = ''
                    return;
                } 
                state.ReviewScreenBookingDetails.serviceName = payload.service || ''
                if(payload.bookingDetail) 
                    state.ReviewScreenBookingDetails.bookings.push(payload.bookingDetail)  
               
                state.ReviewScreenBookingDetails.isPackage = payload.isPackage || ''
                state.ReviewScreenBookingDetails.username = payload.username || ''
                state.ReviewScreenBookingDetails.isEditingService = payload.isEditingService || ''
               
            },
            addGlobalMessage: function(state,obj){
                var vm = this;
                obj.id = new Date().getTime();
                state.globalMessages = []
                state.globalMessages.push(obj);
                if(!obj.noTimeOut){
                    var timeout = setTimeout(function(){
                        vm.commit('removeGlobalMessage',obj.id);
                    },5000)
                    state.globalMessagesTimoutIds[obj.id] = timeout;
                }
            },
            removeGlobalMessage: function(state,id){
                clearTimeout(state.globalMessagesTimoutIds[id])
                state.globalMessages = state.globalMessages.filter(function(err){ return err.id != id });
                state.globalMessagesTimoutIds = _.omit(state.globalMessagesTimoutIds,id);
            },
            setForceUpdate: function(state,bool){
                if(state.forceUpdate == bool) return;
                state.forceUpdate = bool;
            },
            setShowLoaderForBooking: function(state,bool) {
                state.showLoaderForBooking = bool;
            },
            setshowLoaderOnStaffChange: function(state,bool) {
                state.showLoaderOnStaffChange = bool;
            },
            setBookForAllGuestCheckBox:function(state,bool){
                state.bookForAllGuestCheckBox = bool;
            },
            setShowMobileItineraryDropDown:function(state,bool){
                state.showMobileItineraryDropDown = bool
            },
            setUserCalenderEventsSplitDays:function(state,val){
                state.UserCalenderEventsSplitDays = val
            },
            SetselectedTimeOnTimePicker: function(state,bool) {
                state.selectedTimeOnTimePicker  = bool;
            },
            SetmobileViewMessages: function(state,payload){
                var newState = {};
                newState[payload.key] = payload.message
                state.mobileViewMessages = _.extend({}, state.mobileViewMessages, newState);
                var timeout = setTimeout(function(){
                  state.mobileViewMessages={}
                },5000)
            },
            setshowSummaryOnSideBar: function(state,bool){
                state.showSummaryOnSideBar = bool
            },
            setselectedDateOnDateBar:function(state,payload){
                var date = payload.doNotUpdate ? payload.date : payload;
                state.selectedDateOnDateBar = date
            },
            addPackageErrorMsg: function (state, msg) {
                state.packageErrorMessage = [msg]
            },
            setIsBodyBlur:function(state,val){
                    state.is_body_blur = val
               var body =  document.getElementsByClassName("content-spaPackageTpl")[0]
               val? body.classList.add("prevent_body_scroll"):body.classList.remove("prevent_body_scroll")
            },
            setIsFetching: function (state, bool) {
                state.isFetching = bool;
            },
            setViewMode:function(state,bool){
                state.viewMode = bool
            },
            setbookingButtonText:function(state,bool){
                state.bookingButtonText = bool
            },
            setUserCalenderEvents: function (state, events) {
                state.UserCalenderEvents = [].concat(events);
            },
            changeDesktopMode: function (state, bool) {
                state.desktopMode = bool;
            },
            addUserWithId: function (state, payload) {
                if(!payload.id) throw('no user id provided');
                var newState = {};
                newState[payload.id] = payload.name;
                state.usersWithIds = _.extend({},state.usersWithIds, newState);
            },
            setlistOfUsersWithService: function (state, payload) {
                var newState = {}
                 newState[payload.id] = _.extend({}, state.listOfUsersWithService[payload.id])
                 newState= payload.service;
                state.listOfUsersWithService[payload.id] = _.extend({},newState);
            },
            setIsAgeValid: function (state, bool) {
                state.isAgeValid = bool;
            },
            removeSingleService: function (state, payload) {
                if(!payload.userId) throw('no user id provided');
                if (state.isFetching) return;
                var newState = state.users,
                    userId = payload.userId,
                    id = payload.id;
                var idToRemove = id.indexOf('-') > -1 ? id : payload.specific ? id : Object.keys(newState[userId]).filter(function (item) {
                    return item.split('-')[0] == id
                }).slice(-1);
                console.log("debug-1",idToRemove, newState[userId][idToRemove])
                newState[userId] = _.omit(newState[userId], idToRemove);
                id = id.split('-')[0];
                if (state.selectedServices[id]) {
                    state.selectedServices[id].pop();
                    if (state.selectedServices[id].length == 0) delete state.selectedServices[id];
                }
                // if (_.keys(state.users[state.activeUser]).length == 0) {
                //     _.values(state.users).some(function (servicesObj, index) {
                //         if (!_.isEmpty(servicesObj)) {
                //             state.activeUser = index;
                //             return true;
                //         }
                //         return false;
                //     })
                // }
                // state.currentlyEditingService = 0;
                state.users = _.extend({}, state.users, newState);

                var unbookedServices = _.values(newState).some(function (servicesObj, index) { //fix to go back on active step  or until selectedservice issue is fixed
                    return _.values(servicesObj).some(function(service,ind){
                        if(!service.SpaFolioItemId) {
                            state.activeUser = index;
                            state.currentlyEditingService = ind;
                        }
                        return !service.SpaFolioItemId;
                    })
                })
               if (!unbookedServices && state.status!='E' && !payload.donotUpdateURL) {
                   state.activeStep = 0;
                   var dispatcherArr = ['Location'+app.models.spaModel.getSelectedItem('spaLocations').LocationId,activeStepNameMap[state.activeStep]];
                   app.dispatcher.updateURL('spaBooking','package', dispatcherArr, true);
                   state.afterDeleteData = [];
               }
                //end

                if (_.isEmpty(state.selectedServices)){
                    state.activeStep = 0
                    state.afterDeleteData = [];
                    this.commit('setShowMobileItineraryDropDown',false)
                    return;
                };

                var userId = _.keys(state.users)[state.activeUser];
                var serviceName = _.keys(state.users[userId])[state.currentlyEditingService];
                if(state.activeStep == 1) state.afterDeleteData = [userId, serviceName];
            },
            removeServicesInSingleBookMode: function(state){
                this.commit('removeUnbookedServices');
                state.activeUser = 0;
                state.currentlyEditingService = 0;
                state.afterDeleteData = [];
            },
            removeUnbookedServices: function(state){
                var newState = _.extend({}, state.users);
                // _.each(newState, function (user, userKey) {
                //     _.pick(user, function (value, key) {
                //         if (!value.SpaFolioItemId) {
                //             newState[userKey] = _.omit(user, key)
                //             var id = key.split('-')[0];
                //             if (state.selectedServices[id]) {
                //                 state.selectedServices[id].pop();
                //                 delete state.selectedServices[id];
                //                 delete state.selectedServices[key];
                //             }
                //         }
                //     })
                // })
                state.selectedServices= {}
                var usersObj = state.users;
                _.keys(usersObj).forEach(function(userId){
                    _.keys(usersObj[userId]).forEach(function(serviceId){
                        if(!usersObj[userId][serviceId].SpaFolioItemId){
                            newState[userId] = _.omit(newState[userId],serviceId);
                        }
                    })
                })
                state.users = _.extend({}, state.users, newState);
            },
            setFolioTotal: function (state, total) {
                state.folioTotal = total;
            },
            setStore: function (state, newState) {
                if (!newState) newState = initialState();
                Object.keys(newState).forEach(function (key) {
                    state[key] = newState[key];
                })
            },
            singleBookingMode: function(){
                return  localStrings.configuration['singleBookingMode']
             },
            addUser: function (state, payload) {
                if(!payload.userId) throw('no user id provided');
                var newState = {};
                newState[payload.userId] = {}
                state.users = _.extend({}, state.users, newState);
            },
   
            removeGuestMember: function (state, payload) {
                if(!payload.userId) throw('no user id provided');
                _.keys(state.users[payload.userId]).forEach(function (serviceID) {
                    var id = serviceID.split('-')[0];
                    if(state.selectedServices[id]) state.selectedServices[id].pop();
                    if (state.selectedServices[id] && state.selectedServices[id].length == 0) delete state.selectedServices[id];
                });
                state.users = _.extend({}, _.omit(state.users, payload.userId));

                this.commit('setScheduleBtnValidity', {
                            id: payload.userId,
                            action: "remove"
                })
            },
            setLoggedInUser: function (state,payload) {
                if(!payload.userId) throw('no user id provided');
                var name = app.data.FirstName +" "+app.data.LastName;
                state.loggedInUser = name;
                var customerId = payload.userId;
                var newState = {};

                var defaultUserId = state.tempCustomerId || app.data.DefaultCustomerId;
                state.tempCustomerId = null;
                
                var updatedState = _.omit(state.users, defaultUserId) // to handle the case when state is loaded from app.data and more than 1 user exists
                state.usersWithIds = _.omit(state.usersWithIds, app.data.DefaultCustomerId);
                if(!!state.users[defaultUserId]){
                    newState[customerId] = state.users[defaultUserId];
                } else if (state.users[defaultUserId] == undefined){
                    updatedState = {};
                    newState[customerId] = {};
                }
                state.users = _.extend({}, updatedState, newState);
                // assigning existing bookings to logged in user
                if(!state.reservedTimes[defaultUserId]) return;
                newState = {};
                newState[app.data.CustomerId] = state.reservedTimes[defaultUserId];
                updatedState = _.omit(state.reservedTimes, defaultUserId);
                state.reservedTimes = _.extend({}, updatedState, newState);
            },
            setTempUser: function(state){
                var newState = {};
                var customerId = app.data.CustomerId;
                state.tempCustomerId = customerId;
                if(!!state.users[app.data.DefaultCustomerId]) newState[customerId] = state.users[app.data.DefaultCustomerId];
                var updatedState = _.omit(state.users, app.data.DefaultCustomerId);
                state.users = _.extend({}, updatedState, newState);

                if(state.usersWithIds[app.data.DefaultCustomerId]){
                    newState = _.extend({},state.usersWithIds);
                    newState[customerId] = newState[app.data.DefaultCustomerId];
                    state.usersWithIds = _.omit(newState, app.data.DefaultCustomerId);
                }

                if(!state.reservedTimes[app.data.DefaultCustomerId]) return;
                newState = {};
                newState[customerId] = state.reservedTimes[app.data.DefaultCustomerId];
                updatedState = _.omit(state.reservedTimes, app.data.DefaultCustomerId);
                state.reservedTimes = _.extend({}, updatedState, newState);
            },
            addServiceFromFolio: function(state,payload){
                if(!payload.userId) throw('no user id provided');
                var serviceExists = false;
                var vm = this;
                var genderPrefixMap = {
                    X : "select Staff",
                    P : 'No Preference',
                    M : 'male',
                    F : 'female'
                };
                _.keys(state.users[payload.userId]).some(function(item){
                    if(state.users[payload.userId][item].SpaFolioItemId == payload.service.FolioItemId){
                        serviceExists = true;
                        return true;
                    }
                    return false;
                });
                if(serviceExists) return;
                var userId = payload.userId,
                    service = !!payload.service && JSON.parse(JSON.stringify(payload.service)),
                    serviceID = payload.service.ItemId,
                    package_items = !!payload.service.packageItems ? JSON.parse(JSON.stringify(payload.service.packageItems)) : null,
                    timeStamp = new Date().getTime();
                if (!!!userId) {
                    if(!!state.loggedInUser) return;
                    userId = app.data.CustomerId || app.data.DefaultCustomerId;
                }
                service.SpaItemId = serviceID;
                service.CapableStaff = {};
                state.selectedServices[serviceID + "-" + timeStamp] = true;
                var newState = {};
                newState[userId] = _.extend({}, state.users[userId]);
                newState[userId][serviceID + "-" + timeStamp] = {
                    service: service,
                    SpaItemId: serviceID + "-" + timeStamp,
                    SpaFolioItemId: service.FolioItemId,
                    serviceName: service.Details,
                    ServiceTime: moment(service.FinishDate,'YYYY-MM-DDHHmmss').diff(moment(service.StartDate,'YYYY-MM-DDHHmmss'),'minutes'),
                    date: moment(service.StartDate,'YYYY-MM-DDHHmmss').format(localStrings.stepper.body.schedule.dateBarDaysFormat ),
                    time: moment(service.StartDate,'YYYY-MM-DDHHmmss').format('hh:mm a'),
                    preferedDate: moment(service.StartDate,'YYYY-MM-DDHHmmss').format(localStrings.stepper.body.schedule.dateBarDaysFormat),
                    bookingStatus: "Booked",
                    price: service.Amount,
                    note:service.GuestRequest,
                    username: state.usersWithIds[userId],
                    bookingDetails: {
                        SpaStaffId: service.StaffId,
                        StartDateTime: service.StartDate,
                        endDateTime: service.FinishDate
                    },
                    CapableStaff: [],
                    staffName : service.StaffRequested == 'Y' ? service.StaffName : genderPrefixMap[service.StaffRequestedGender]
                };

                if(!_.isEmpty(newState[userId][serviceID + "-" + timeStamp]) && state.OTBactive){
                    newState[userId][serviceID + "-" + timeStamp].staffGenderOrId = service.StaffId;
                }
                
                if(!!package_items){
                    package_items.forEach(function(packageItem){
                        packageItem.ItemName = packageItem.Details;
                        packageItem.SpaItemId = packageItem.ItemId;
                        packageItem.staffGenderOrId = packageItem.StaffId;
                        packageItem.dateTime = packageItem.StartDate;
                        packageItem.SpaFolioItemId = packageItem.FolioItemId;
                        packageItem.time = moment(packageItem.StartDate,'YYYY-MM-DDHHmmss').format('hh:mm a');
                    });
                    newState[userId][serviceID + "-" + timeStamp].package_item = {
                        PackageItems : {
                            PackageItem : package_items,
                        },
                        SpaPackageId : serviceID,
                        Price : service.Amount,
                        PriceWithSurcharges : service.AmountWithSurcharges,
                        PackageName : service.Details
                    }
                }
                // if (!state.selectedServices[serviceID]) state.selectedServices[serviceID] = [];
                // state.selectedServices[serviceID + "-" + timeStamp] = true;
                // state.selectedServices[serviceID].push(user);
                state.users = _.extend({}, state.users, newState);
            },
            addCapableStaffToService: function(state,service){
                if(service.PackageItems) return;
                _.keys(state.users).some(function(userId){
                    return _.keys(state.users[userId]).some(function(serviceId){
                        if(state.users[userId][serviceId].service.SpaItemId == service.SpaItemId && state.users[userId][serviceId].CapableStaff.length==0){
                            state.users[userId][serviceId].CapableStaff = service.CapableStaff.Staff;
                            state.users[userId][serviceId].service.CapableStaff = service.CapableStaff;
                            return true;
                        }
                        return false;
                    });
                });
            },
            //new methods related to optional class programs -- START
            intializeClassComponentPerUser:function(state,payload){
                var newState = {}
                _.each(state.users,function(val,key){
      
                    newState[key] = _.extend({}, state.users[key]);
                    var modifiedComponents = _.groupBy(payload.classComponents, 'OptionalComponent')
                    newState[key]['classComponents'] = modifiedComponents
                    state.users = _.extend({}, state.users, newState);
                })
               
            },
            addCurrentlyBookingClassProgram:function(state,val){
                state.currentlyBookingClassProgram = val
            },
            addAgeForUser:function(state,payload){
                //Add birthdate 
                var newState = {}
                newState[payload.userId] = _.extend({}, state.users[payload.userId]);
                if(payload.birthdate){
                    newState[payload.userId]['birthdate'] = payload.birthdate
                    var age = moment().diff(payload.birthdate, 'years',false);
                    newState[payload.userId]['age'] = age
                }
                state.users = _.extend({}, state.users, newState);
            },
            addEventPerUserDetails:function(state,payload){
                //Add EVENT details; could be different per user
                var newState = {}
                newState[payload.userId] = _.extend({}, state.users[payload.userId]);
                newState[payload.userId]['eventName'] = payload.eventName
                newState[payload.userId]['eventPrice'] = payload.eventPrice
                newState[payload.userId]['isBookingClass'] = payload.isBookingClass
                state.users = _.extend({}, state.users, newState);
            },
            removeOptionalClassesIds:function(state,payload){
                // remove those optional classes from user list that has min or maxAge set
                // this funtion runs when user clear date of birth from datepicker
                var newState = {}
                newState[payload.userId] = _.extend({}, state.users[payload.userId]);
                var optionalClasses = newState[payload.userId]['classComponents']['Y']
                _.each(optionalClasses,function(item){
                    if( item.MinAge || item.MaxAge){
                        delete newState[payload.userId]['optionalClassListIds'][item.SpaClassId] // if exist
                    }
                })
                state.users = _.extend({}, state.users, newState);
            },
            removeInvalidClassIds: function (state, payload) {
                // remove those optional classes from user list that doesnt satisfies age restriction(user age may be above or below required)
                // this funtion runs when user changes date of birth from datepicker and may have some optional classes added before changing it
                var newState = {}
                newState[payload.userId] = _.extend({}, state.users[payload.userId]);
                var user = newState[payload.userId]
                var optionalClasses = user['classComponents']['Y'] 
                !_.isEmpty(optionalClasses) && user.birthdate ? _.each(optionalClasses, function (item) {
                    if (item.MinAge && user.age < item.MinAge || item.MaxAge && user.age > item.MaxAge) {
                        delete user['optionalClassListIds'][item.SpaClassId] // if exist
                    }
                }) : ''
                state.users = _.extend({}, state.users, newState);
            },
            configureOptionalSpaItemId:function(state,payload){
                var newState = {}
                newState[payload.userId] = _.extend({}, state.users[payload.userId]);
                var optionalClassListIds = newState[payload.userId]['optionalClassListIds'] || {}
                newState[payload.userId]['optionalClassListIds'] = optionalClassListIds
                if(payload.action == "add" ){
                    if(!optionalClassListIds[payload.SpaClassId]) optionalClassListIds[payload.SpaClassId] = true;
                }
                else{
                    if(optionalClassListIds[payload.SpaClassId]) delete optionalClassListIds[payload.SpaClassId]
                }
                state.users = _.extend({}, state.users, newState);
            },
            removeUser: function (state, payload) {
                if(!payload.userId) throw('no user id provided');
                state.users = _.extend({}, _.omit(state.users, payload.userId));
            },
           
             //new methods related to optional class programs -- END
            addService: function (state, payload) {
                if(!payload.userId) throw('no user id provided');
                payload.service = payload.service || {};
                if(!payload.service.LocationId){
                    payload.service.LocationId = payload.service.Location;
                }

                var userId = app.data.userLoggedIn ? payload.userId : null,
                    service = !!payload.service && JSON.parse(JSON.stringify(payload.service)),
                    setSelected = payload.setSelected,
                    serviceID = payload.service.SpaItemId,
                    package_item = !!payload.package_item && JSON.parse(JSON.stringify(payload.package_item)),
                    timeStamp = new Date().getTime();
                if (!!!userId) userId = app.data.CustomerId || app.data.DefaultCustomerId;

                if(payload.setSelected){
                    var serviceExists = _.keys(state.users[userId]).some(function(serviceIdWithTS){
                        return !state.users[userId][serviceIdWithTS].SpaFolioItemId && serviceIdWithTS.split('-')[0] == serviceID;
                    });

                    if(serviceExists) return;
                }

                var newState = {};
                newState[userId] = _.extend({}, state.users[userId]);
                if (setSelected) {
                    newState[userId][serviceID + "-" + timeStamp] = {
                        service: service,
                        ActivityName: service.ItemCategory,
                        serviceName: service.ItemName,
                        ServiceTime: service.ServiceTime,
                        staffGenderOrId: localStrings.sideCart.service.body.selectStaff,
                        staffName: localStrings.stepper.body.schedule.dropdown.selectStaff.gender,
                        CapableStaff: (service.CapableStaff || {}).Staff,
                        date: undefined,
                        time: undefined,
                        preferedTime: undefined,
                        preferedDate: undefined,
                        bookingStatus: localStrings.sideCart.service.body.bookingStatus.notBooked,
                        price: service.Price,
                        note:"",
                        bookingDetails:{
                            StartDateTime:""
                        }
                    };
                    if (package_item) {
                        package_item.PackageItems.PackageItem.forEach(function (item) {
                            item.time = undefined;
                            item.preferedTime = undefined,
                                item.note = "",
                                item.dateTime = ""
                                item.bookingStatus = localStrings.sideCart.service.body.bookingStatus.notBooked,
                                item.staffGenderOrId = localStrings.sideCart.service.body.selectStaff,
                                item.staffName = localStrings.stepper.body.schedule.dropdown.selectStaff.gender
                        })
                        newState[userId][serviceID + "-" + timeStamp].package_item = package_item;
                        // Vue.set(newState[user][serviceID],'package_item',package_item)
                    }
                    var newState1 = JSON.parse(JSON.stringify(state.selectedServices));
                    if (!newState1[serviceID]) newState1[serviceID] = [];
                    newState1[serviceID + "-" + timeStamp] = true;
                    newState1[serviceID].push(userId);
                    state.selectedServices = newState1;
                } else {
                    var singleBookingMode = localStrings.configuration['singleBookingMode']
                    newState[userId] = _.omit(newState[userId], function (val, key) {
                        var singleBookingModeCondition = singleBookingMode?(key.split('-')[0] == serviceID &&val.SpaFolioItemId):false
                        if (key.split('-')[0] != serviceID ||singleBookingModeCondition) return false;
                        state.selectedServices[serviceID].pop();
                        return true;
                    });
                    if ((state.selectedServices[serviceID] || []).length == 0) delete state.selectedServices[serviceID];
                }
                state.users = _.extend({}, state.users, newState);
            },
            setActiveStep: function (state, payload) {
                var step = payload.doNotUpdate ? activeStepNameMap.indexOf(payload.step) : payload;
                if(payload.step=='Edit') {
                    this.commit('setStatus', 'E');
                    step = 1;
                };
                if(isNaN(step)) step = activeStepNameMap.indexOf(step);
                var bool = false;
                if(step != state.activeStep) bool = true;
                if ( step < 0 || step > 2) return;
                if(step == 1){
                    if (_.keys(state.users[state.activeUser]).length == 0) {
                        _.values(state.users).some(function (servicesObj, index) {
                            if (!_.isEmpty(servicesObj)) {
                                state.activeUser = index;
                                return true;
                            }
                            return false;
                        })
                    }                    
                } else if(state.status == 'E'){
                    state.status = '';
                }

                if(step == 0 && localStrings.configuration['singleBookingMode']){
                    this.commit('removeServicesInSingleBookMode')
                }
                state.activeStep = step;
                if(bool){
                    var dispatcherArr = getDispatcherArr(state);
                    state.urlUpdated = true;
                    app.dispatcher.redirect('spaBooking','package', dispatcherArr);
                }

                // clear lastFetchDate
                state.lastFetchDate = '';
            },
            changeActiveService: function (state, payload) {
                if ((state.isFetching || state.activeStep!=1) && !payload.allow) return;
                if (payload.user >= 0) state.activeUser = payload.user;
                state.currentlyEditingService = payload.id;
            },
          
            AddHiddenReservedTime: function (state, payload) {
                state.HiddenReservedPackageItems = {}
                state.HiddenReservedPackageItems = payload
            },
            addReservedTime: function (state, payload) {
     
                var reservedTimes = state.reservedTimes[payload.id] || [];
                var newState = {};
                var alreadyHasBooking = reservedTimes.some(function (item) {
                    if(payload.data.bookingType == "pmsBooking"){
                        return item.folioid == payload.data.folioid

                    }
                    else {
                        return item.SpaFolioItemId == payload.data.SpaFolioItemId
                    }                    
                })
                newState[payload.id] =reservedTimes
 
                !alreadyHasBooking?  newState[payload.id] = reservedTimes.concat(payload.data):''
                state.reservedTimes = _.extend({}, state.reservedTimes, newState);
            },
            removeReservedTime: function (state, payload) {
                if(!payload.userId) throw('no user id provided');
                var newState = {};
                newState[payload.userId] = (state.reservedTimes[payload.userId] || []).filter(function (item) {
                    return [item.SpaFolioItemId, item.parentSpaFolioItemId].indexOf(payload.FolioItemId) == -1;
                })
                state.reservedTimes = _.extend({}, state.reservedTimes, newState);
            },
            emptyReservedTime: function(state,payload){
                state.reservedTimes = {};
            },
            addGroupMember: function (state, name) {
                if (state.groupMembers.indexOf(name) == -1)
                    state.groupMembers.push(name);
            },
            addGuestProfile: function(state,profile){
                state.guestProfiles[profile.CustomerId] = profile
            },
            //setters
            setStaff: function (state, payload) {
                if(!payload.userId) throw('no user id provided');
                //var newState = _.extend({}, state.users);
                    var newState = JSON.parse(JSON.stringify(state.users));
                // var service  = state.users[payload.usernamename][payload.id]
                // service.staff= payload.staff
                // payload.staffname ? service.staffname = payload.staffname:service.staffname = undefined
                if(payload.isPackage){
                    console.log(" payload",payload)
                    var package_item = newState[payload.userId][payload.id].package_item.PackageItems.PackageItem
                    var itemIndex = package_item.findIndex(function (obj) { // index of currently editing item
                        return obj.SpaItemId == payload.packageItemId
                    })
                    package_item[itemIndex].staffGenderOrId = payload.staffGenderOrId
                    package_item[itemIndex].staffName = payload.staffName
                    package_item[itemIndex].staffGender = payload.staffGender
                }
                else{
                       var service  = newState[payload.userId][payload.id]
                       service.staffGenderOrId = payload.staffGenderOrId
                       service.staffName = payload.staffName
                       service.staffGender = payload.staffGender
                }
                state.users = _.extend({}, state.users, newState);
            },
            setDate: function (state, payload) {
                if(!payload.userId) throw('no user id provided');
                state.users[payload.userId][payload.id].date = payload.date;
            },
            setStatus: function (state, status) {
                if(status == 'E'){
                    this.commit('removeUnbookedServices');
                }
                state.status = status
            },
            setPreferedDate: function (state, payload) {
                if(!payload.userId) throw('no user id provided');
                var newState = _.extend({}, state.users);
                newState[payload.userId][payload.id].preferedDate = payload.preferedDate;
                state.users = _.extend({}, state.users, newState);
            },
            setPreferedTime: function (state, payload) {
                if(!payload.userId) throw('no user id provided');
                var newState = _.extend({}, state.users);
                if (payload.isPackage) {
                    newState[payload.userId][payload.id].package_item.PackageItems.PackageItem[state.activePackageItem].preferedTime = payload.preferedTime
                }
                newState[payload.name][payload.id].preferedTime = payload.preferedTime
                state.users = _.extend({}, state.users, newState);
            },
            setBookingTime: function (state, payload) {
                if(!payload.userId) throw('no user id provided');
                var newState = _.extend({}, state.users);
                if (payload.isPackage) {
               
                    var package_item = newState[payload.userId][payload.id].package_item.PackageItems.PackageItem
                     var index = package_item.findIndex(function (obj) { // index of currently editing item
                        return obj.SpaItemId == payload.itemId
                    })
                     package_item = package_item[index]
      
                    package_item.time = payload.time
                    package_item.dateTime = payload.dateTime
                } else {
                    newState[payload.userId][payload.id].time = payload.time
                }
                state.users = _.extend({}, state.users, newState);
            },
            setPackageBookingInfo: function (state, payload) {
                if(!payload.userId) throw('no user id provided');
                var newState = _.extend({}, state.users);
                
                    newState[payload.userId][payload.id].bookingDetails = payload.bookingDetails
                    newState[payload.userId][payload.id].bookingStatus = payload.bookingStatus
                    newState[payload.userId][payload.id].SpaFolioItemId = payload.SpaFolioItemId
                
                state.users = _.extend({}, state.users, newState);
            },

            setNote: function (state, payload) {
                if(!payload.userId) throw('no user id provided');
                var newState = _.extend({}, state.users);
            
                if (payload.isPackage) {
         
                    var package_item = newState[payload.userId][payload.id].package_item.PackageItems.PackageItem
                    var index = package_item.findIndex(function (obj) { // index of currently editing item
                        return obj.SpaItemId == payload.packageItemId
                    })
                    console.log("not",package_item[index])
                    package_item[index].note = payload.note
                }
                else  newState[payload.userId][payload.id].note = payload.note
                state.users = _.extend({}, state.users, newState);
            },
            setBookingStatusAndFolio: function (state, payload) {
                if (!payload.userId) throw ('no user id provided');

                var newState = _.extend({}, state.users);
                if (payload.isPackage) {

                    var package_item = newState[payload.userId][payload.id].package_item.PackageItems.PackageItem
                    var index = package_item.findIndex(function (obj) { // index of currently editing item
                        return obj.SpaItemId == payload.itemId
                    })
                    // if (payload.isEditingPackage) {
                    //     if (index != payload.index) {
                    //         var old = package_item[payload.index]
                    //         package_item[payload.index] = package_item[index]
                    //         package_item[index] = old
                    //     }
                    // }
                    package_item[index].bookingStatus = payload.bookingStatus
                    package_item[index].SpaFolioItemId = payload.SpaFolioItemId
                    package_item[index].autoAssignedStaff = payload.autoAssignedStaff;
                    package_item[index].autoAssignedStaffName = payload.autoAssignedStaffName;
                    package_item[index].staffGender = payload.staffGender;

                } else {
                    newState[payload.userId][payload.id].bookingStatus = payload.bookingStatus;
                    newState[payload.userId][payload.id].SpaFolioItemId = payload.SpaFolioItemId;
                    newState[payload.userId][payload.id].bookingDetails = payload.bookingDetails;
                    newState[payload.userId][payload.id].autoAssignedStaff = payload.autoAssignedStaff;
                    newState[payload.userId][payload.id].autoAssignedStaffName = payload.autoAssignedStaffName;
                    newState[payload.userId][payload.id].staffGender = payload.staffGender;
                }
                state.users = _.extend({}, state.users, newState);
            },
            sortPackageItems: function(state,payload){ // This is for sorting package items based on time.
                var newState = _.extend({}, state.users);
                var package_items = newState[payload.userId][payload.id].package_item.PackageItems.PackageItem
                package_items.sort(function(a, b) {
                     return (a.dateTime > b.dateTime) ? 1 : -1})
                // var a1 = moment(a.dateTime,'YYYY-MM-DDHHmmss')
                // var a2 = moment(b.dateTime,'YYYY-MM-DDHHmmss')
                
                state.users = _.extend({}, state.users, newState);
            },
            reorderPackageItems: function (state, payload) { //this is resposible for reordering items in store based on book order of package  
                //when user clicks on time. This is just for display purposes so user can see on side cart what order package is going to book. BNecause 
                // items may have same book order so they can interchange.
                if(!payload.userId) throw('no user id provided');
                var newState = _.extend({}, state.users);
                var package_items = newState[payload.userId][payload.id].package_item.PackageItems.PackageItem
                _.each(payload.highestCominations, function (itemId, index) {
                    var pckIndex = package_items.findIndex(function (obj) { // index of currently editing item
                        return obj.SpaItemId == itemId
                    })
                    if (pckIndex != index) {
                        var old = package_items[index]
                        package_items[index] = package_items[pckIndex]
                        package_items[pckIndex] = old
                    }
                })
                state.users = _.extend({}, state.users, newState);
         
            },
            setActiveUser: function (state, payload) {
                state.activeUser = parseInt(payload)
            },
            setActivePackageItem: function (state, payload) {
                state.activePackageItem = parseInt(payload)
            },
            setDynamicRestErrorMessage: function(state, payload){
                state.dynamicRestErrorMessage = payload;
            },
            setLastFetchDate: function(state, payload){
                state.lastFetchDate = payload;
            },
            setNoAvails: function(state, payload){
                state.noAvails = payload;
            }
       
        },

    })
});
